<template>
  <tr>
    <td>
      <v-text-field v-model="localItem.title" dense hide-details solo :disabled="!editing"/>
    </td>
    <td>
      <v-text-field v-model="localItem.description" dense hide-details solo :disabled="!editing"/>
    </td>
    <td>
      <v-btn small :disabled="!editing" @click="filterDialog = true" :color="(localItem.filter || item.filter) ? 'primary' : ''" text>Suodatin</v-btn>
      <v-dialog v-model="filterDialog" max-width="1200">
        <v-card>
          <v-card-title>Muokkaa suodatinta</v-card-title>
          <v-card-text>
            <CreateFilter @input="handleSave($event)" :initFilter="localItem.filter" :report="true" />
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn color="primary" text @click="filterDialog = false">Tallenna</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </td>
    <td>
      <v-text-field
        v-model.number="localItem.percentage_checked"
        type="number"
        min="1"
        max="100"
        dense
        hide-details
        solo
        :disabled="!editing"
        suffix="%"
      />
    </td>
    <td>
      <v-select
        v-model="localItem.view"
        :items="viewOptions"
        dense
        hide-details
        solo
        :disabled="!editing"
      />
    </td>
    <td>
      <v-text-field
        v-model="localItem.event_key"
        dense
        hide-details
        solo
        :disabled="!editing"
      />
    </td>
    <td>
      <v-text-field
        v-model.number="localItem.analysis_phase"
        type="number"
        step="0.1"
        min="0"
        max="10"
        dense
        hide-details
        solo
        :disabled="!editing"
      />
    </td>
    <td>
      <v-text-field
        v-model="localItem.leagues"
        dense
        hide-details
        solo
        :disabled="!editing"
        maxlength="4"
        style="max-width: 60px;"
      />
    </td>
    <td>
      <v-switch v-model="localItem.archived" :disabled="!editing" hide-details dense/>
    </td>
    <td>
      <v-btn icon v-if="!editing" @click="$emit('edit')"><v-icon color="primary">mdi-pencil</v-icon></v-btn>
      <v-btn icon v-else @click="emitSave"><v-icon color="green">mdi-content-save</v-icon></v-btn>
      <v-btn icon @click="$emit('archive')"><v-icon color="red">mdi-archive</v-icon></v-btn>
    </td>
  </tr>
</template>

<script>
import CreateFilter from '@/components/filters/CreateFilter.vue'

export default {
  name: 'QualityControlItemRow',
  components: { CreateFilter },
  props: {
    item: Object,
    editing: Boolean
  },
  data() {
    return {
      localItem: { ...this.item },
      filterDialog: false,
      viewOptions: [
        { text: 'Yleinen', value: 'general' },
        { text: 'Arvo', value: 'value' },
        { text: 'Kartta', value: 'map' },
        { text: 'Aika', value: 'time' }
      ]
    }
  },
  watch: {
    item: {
      handler(val) {
        this.localItem = { ...val }
      },
      deep: true
    }
  },
  methods: {
    emitSave() {
      this.$emit('save', { ...this.localItem })
    },
    handleSave(filter) {
      this.localItem.filter = filter
    }
  }
}
</script>

<style scoped>
tr {
  font-size: 13px;
  height: 36px;
}
td {
  padding: 2px 4px !important;
}
tr:nth-child(even) {
  background: #f7f7fa;
}
tr:nth-child(odd) {
  background: #fff;
}
</style>